import APIPersonDomainService from "../APIPerson/APIPerson.service";
export default class PersonInfoDomainService {
    static fromJSON(json) {
        return Object.assign(Object.assign({}, json), { person: APIPersonDomainService.fromJSON(json.person) });
    }
}
